module.exports = __webpack_public_path__ + "img/list.a07a0f14.svg";